import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ReportWorkOrderListItem = ResultOf<
  typeof reportWorkOrderListQuery
>["reportWorkOrders"][number];

export const reportWorkOrderListQuery = graphql(`
  query ReportWorkOrderList($rangeStartDate: String!, $rangeEndDate: String!) {
    reportWorkOrders(
      range_start_date: $rangeStartDate
      range_end_date: $rangeEndDate
    ) {
      id
      work_order_reference
      work_order_status
      currency
      created_at
      supplier_name
      departure_city
      delivery_city
      invoice_id
      invoice_reference
      invoice_status
      invoice_amount_exc_tax
      invoice_amount_exc_tax_wo_currency
      invoice_amount_exc_tax_aud
      total_claimed_expenses
      total_claimed_expenses_aud
      total_expected_payout
      total_expected_payout_aud
      total_payouts
      total_payouts_aud
      profit
      profit_aud
    }
  }
`);

export type ReportWorkOrderDetail = NonNullable<
  ResultOf<typeof reportWorkOrderDetailQuery>["workOrder"]
>;

export type ReportWorkOrderAssignment =
  ReportWorkOrderDetail["assignments"][number];

export type ReportWorkOrderExpense =
  ReportWorkOrderAssignment["expenses"][number];

export type ReportWorkOrderPayout =
  ReportWorkOrderAssignment["payouts"][number];

export const reportWorkOrderDetailQuery = graphql(`
  query ReportWorkOrderDetail($id: ID!) {
    workOrder(id: $id) {
      id
      currency
      assignments {
        id
        proDriver {
          name
        }
        expenses {
          id
          type
          paid_by
          paid_to
          amount
          payout_amount
          currency
          description
          created_at
        }
        payouts {
          id
          amount
          amount_tax
          currency
          converted_amount
          converted_currency
          exchange_rate
          transaction_reference
          paid_at
        }
      }
    }
  }
`);
